import { defaultTheme, LoginProvider, LoginProviderProps, NamedContext, QueryProvider } from '@2r/frontend-component-library';
import { ThemeProvider } from '@emotion/react';
import Cookies from 'js-cookie';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import App from './App';
import { Home } from './components/Home';
import { FrameEditPartnership } from './frames/FrameEditPartnership';
import { FrameEditUser } from './frames/FrameEditUser';
import { FrameListPartnerships } from './frames/FrameListPartnerships';
import { FrameListUsers } from './frames/FrameListUsers';
import { Login } from './Login/Login';

const loginProviderConfig: LoginProviderProps = {
    onLogin: (token: string) => Cookies.set('token', token, { expires: 1, secure: true }),
    onLogout: () => Cookies.remove('token'),
    initialToken: Cookies.get('token') ?? '',
};

export default function CommServerRoutes() {
    const AppRoutes: RouteObject[] = [
        {
            path: '/',
            element: <App />,
            children: [
                {
                    index: true,
                    element: <Home />
                },
                {
                    path: 'benutzer',
                    children: [
                        {
                            path: 'list',
                            element: <FrameListUsers />
                        },
                        {
                            path: '',
                            children: [
                                {
                                    path: ':userID',
                                    element: <FrameEditUser />
                                },
                                {
                                    path: 'new',
                                    element: <FrameEditUser New />
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'partnerschaften',
                    children: [
                        {
                            path: 'list',
                            element: <FrameListPartnerships />
                        },
                        {
                            path: '',
                            children: [
                                {
                                    path: ':partnershipID',
                                    element: <FrameEditPartnership />
                                },
                                {
                                    path: 'new',
                                    element: <FrameEditPartnership New />
                                }
                            ]
                        }
                    ]
                },
            ]
        },
        {
            path: '/login',
            element: <Login />
        }
    ];

    const CommServerRouter = createBrowserRouter(AppRoutes);

    return (
        <ThemeProvider theme={defaultTheme}>
            <QueryProvider>
                <LoginProvider {...loginProviderConfig}>
                    <NamedContext Name="david.commserver">
                        <RouterProvider router={CommServerRouter} />
                    </NamedContext>
                </LoginProvider>
            </QueryProvider>
        </ThemeProvider>
    );
};
